
import { ILocationWithIds } from '@/types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Button,
  Box,
  Typography,
  alpha,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility'
import { useTheme } from '@mui/material/styles';
import { formatDate, formatDateTime } from '@/utils/dateUtils';
import { getIcon } from './icons/getIcon';
import { RouteCell } from '@/pages/load-service/components/common/RouteCell';
import { error } from 'console';
import AppDialog from '@/components/ui/AppDialog';

/* ── Toggle: true = new route UI, false = old View() button ── */
const USE_ROUTE_UI = true;
// Address Modal Component
// Address Modal Component
const AddressModal: React.FC<{ addressModalOpen: any, setAddressModalOpen: any, selectedAddresses: any, }> = ({ addressModalOpen, selectedAddresses, setAddressModalOpen }) => {
  // Function to close address modal
  const closeAddressModal = () => {
    setAddressModalOpen(false);
  };
  return (
    <AppDialog
      open={addressModalOpen}
      onClose={closeAddressModal}
      maxWidth="sm"
      fullWidth
       PaperProps={{
        elevation: 0,
        className: "customDailog-modal",
        sx: { borderRadius: 1 }
      }}
    >
    <DialogActions className="dialog-close">
      <Button onClick={closeAddressModal} sx={{color:'#101721'}}>
      {getIcon('CloseIcon')}
      </Button>
    </DialogActions>

    <DialogTitle style={{borderBottom:'1px solid #ddd', paddingBottom:'12px'}}>
    <Typography sx={{ fontWeight: 600, fontSize: '15px' }}>{selectedAddresses.title}</Typography>
    </DialogTitle>

      <DialogContent
        sx={{
          p: {xs:1.7, md:3},
          bgcolor: "#fff",
        }}
      >
  <List sx={{ p: 0 }}>
    {selectedAddresses.locations.map(
      (loc: ILocationWithIds, index: number) => (
        <ListItem
          key={`${loc._id}-${index}`}
          divider={index < selectedAddresses.locations.length - 1}
          alignItems="flex-start"
          sx={{
            px: 0,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          {/* LEFT CIRCLE + LINE */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mr:{xs:1, md:2},
              mt: 0.5,
            }}
          >
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                bgcolor:
                  selectedAddresses.type === "pickup"
                    ? "#16a34a"
                    : "#0061ff",
                border: "3px solid #dcfce7",
                zIndex: 2,
              }}
            />

            {index < selectedAddresses.locations.length - 1 && (
              <Box
                sx={{
                  width: 2,
                  flex: 1,
                  minHeight: 110,
                  bgcolor: "#d1d5db",
                  mt: 0.5,
                }}
              />
            )}
          </Box>

          {/* RIGHT CONTENT */}
          <Box sx={{ flex: 1 }}>
            {/* TITLE */}
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 700,
                color:
                  selectedAddresses.type === "pickup"
                    ? "#15803d"
                    : "#0061ff",
                mb: 0.3,
              }}
            >
              {selectedAddresses.type === "pickup"
                ? "Pickup"
                : "Delivery"}{" "}
              {index + 1}
            </Typography>

            {/* LOCATION */}
            <Typography
              sx={{
                fontSize:{xs:15, md:16},
                fontWeight: 600,
                color: "#111827",
                lineHeight: 1.3,
              }}
            >
              {loc.city}, {loc.state}
            </Typography>

            {/* ADDRESS */}
            <Typography
              sx={{
                fontSize: {xs:12, md:13},
                color: "#6b7280",
                mt: 0.3,
                mb: 1.2,
              }}
            >
              {loc.address}
            </Typography>

            {/* DATE CARDS */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              {/* CHECK IN */}
              <Box
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: 0.5,
                  bgcolor: "#ffffff",
                  border: "1px solid #e5e7eb",
                  minWidth:{xs:'100%', md:140},
                }}
              >
                <Typography
                  sx={{
                    fontSize: 11,
                    color: "#6b7280",
                    mb: 0.3,
                  }}
                >
                  Check In
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#111827",
                  }}
                >
                  {loc.checkin
                    ? formatDateTime(loc.checkin)
                    : "Not Checked In"}
                </Typography>
              </Box>

              {/* CHECK OUT */}
              <Box
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: 0.5,
                  bgcolor: "#ffffff",
                  border: "1px solid #e5e7eb",
                  minWidth:{xs:'100%', md:140},
                }}
              >
                <Typography
                  sx={{
                    fontSize: 11,
                    color: "#6b7280",
                    mb: 0.3,
                  }}
                >
                  Check Out
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#111827",
                  }}
                >
                  {loc.checkout
                    ? formatDateTime(loc.checkout)
                    : "Not Checked Out"}
                </Typography>
              </Box>

              {/* PICKUP / DELIVERY */}
              <Box
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: 0.5,
                  bgcolor:
                    selectedAddresses.type === "pickup"
                      ? "#ecfdf5"
                      : "#e5efff",
                  border:
                    selectedAddresses.type === "pickup"
                      ? "1px solid #bbf7d0"
                      : "1px solid #b4cbf0",
                  minWidth: {xs:'100%', md:200},
                }}
              >
                <Typography
                  sx={{
                    fontSize: 11,
                    color:
                      selectedAddresses.type === "pickup"
                        ? "#15803d"
                        : "#0061ff",
                    mb: 0.3,
                  }}
                >
                  {selectedAddresses.type === "pickup"
                    ? "Pickup"
                    : "Delivery"}{" "}
                  Date & Time
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color:
                      selectedAddresses.type === "pickup"
                        ? "#15803d"
                        : "#0061ff",
                  }}
                >
                  {loc.combinedDateTime
                    ? `${formatDateTime(loc.combinedDateTime)}`
                    : "Not Available"}
                </Typography>
              </Box>
            </Box>

            {/* END TIME */}
            {loc.combineEnddDateTime && (
              <Typography
                sx={{
                  fontSize: 12,
                  color: 'red',
                  mt: 1.2,
                  textAlign:'right',
                  pr:2.5,
                }}
              >
                End Time:{" "}
                <strong>
                  {formatDateTime(loc.combineEnddDateTime)}
                </strong>
              </Typography>
            )}
          </Box>
        </ListItem>
      )
    )}
  </List>
</DialogContent>

      <DialogActions style={{padding:'0px 20px 15px 20px', gap:1}}>
        <Button
          onClick={closeAddressModal}
          variant="outlined"
          size="medium"
        >
          Close
        </Button>
      </DialogActions>
    </AppDialog>
  );
};
const renderAddress = (locations: ILocationWithIds[] | undefined, loadId: string, type: string, setAddressModalOpen: any, setSelectedAddresses: any, expandedAddresses: any, setExpandedAddresses: any) => {

  if (!locations || locations.length === 0) return '-';

  // Function to open address modal
  const openAddressModal = (locs: ILocationWithIds[], locType: string) => {
    setSelectedAddresses({
      locations: locs,
      title: locType === 'pickup' ? 'Origin Addresses' : 'Destination Addresses',
      type: locType,
    });
    setAddressModalOpen(true);
  };

  if (USE_ROUTE_UI) {
    const routeOpenModal = (modalType: 'pickup' | 'delivery', data: ILocationWithIds[], title: string) => {
      setSelectedAddresses({ locations: data, title, type: modalType });
      setAddressModalOpen(true);
    };
    return (
      <RouteCell
        locations={locations}
        type={type as 'pickup' | 'delivery'}
        openModal={routeOpenModal}
      />
    );
  }

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>

        <Button
          color="primary"
          startIcon={<VisibilityIcon />}
          onClick={(e) => {
            e.stopPropagation();
            openAddressModal(locations, type);
          }}
          sx={{
            ml: 1,
            p: 0,
            minHeight: 'auto',
            minWidth: 'auto',
            textTransform: 'none',
            fontSize: '0.84rem',
            color:'#101721',
            fontWeight: 400,
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline'
            },
             '& .MuiButton-startIcon svg': {
                marginRight: '-3px',
                color:'#333',
                fontSize:'14px',
              },
          }}
        >
          View({locations.length})
        </Button>
      </Box>
    </Box>
  );
};

// Current Location Modal Component
const CurrentLocationModal: React.FC<{
  currentLocationModalOpen: any,
  setCurrentLocationModalOpen: any,
  selectedLocation: any,
}> = ({ currentLocationModalOpen, setCurrentLocationModalOpen, selectedLocation }) => {
  const closeCurrentLocationModal = () => {
    setCurrentLocationModalOpen(false);
  };

  return (
    <AppDialog
      open={currentLocationModalOpen}
      onClose={closeCurrentLocationModal}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        elevation: 0,
        className: "customDailog-modal",
        sx: { borderRadius: 1 }
      }}
    >
      <DialogActions className="dialog-close">
        <Button onClick={closeCurrentLocationModal}>
          {getIcon('CloseIcon')}
        </Button>
      </DialogActions>

      <DialogTitle style={{borderBottom:'1px solid #ddd', paddingBottom:'12px'}}>
        <Typography fontSize={15} fontWeight={600}>Current Location & Notes</Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          p: {xs:1.7, md:3},
          bgcolor: "#fff",
        }}
      >
        {/* Current Location Section */}
        <Box sx={{mt:3, mb:2}}>
          <Box
            sx={{
              px: 1.5,
              py: 1,
              borderRadius: 0.5,
              bgcolor: "#f3f4f6",
              border: "1px solid #e5e7eb",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: "#111827",
                lineHeight: 1.4,
              }}
            >
              {selectedLocation?.currentLocation || 'N/A'}
            </Typography>
          </Box>
        </Box>

        {/* Notes Section */}
        {selectedLocation?.notes && (
          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 700,
                color: "#1f2937",
                mb: 1,
              }}
            >
              Notes
            </Typography>
            <Box
              sx={{
                px: 1.5,
                py: 1,
                borderRadius: 0.5,
                bgcolor: "#fef3c7",
                border: "1px solid #fcd34d",
              }}
            >
              <Typography
                sx={{
                  fontSize: 14,
                  color: "#92400e",
                  lineHeight: 1.5,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {selectedLocation.notes}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions style={{padding:'0px 20px 15px 20px', gap:1}}>
        <Button
          onClick={closeCurrentLocationModal}
          variant="outlined"
          size="medium"
        >
          Close
        </Button>
      </DialogActions>
    </AppDialog>
  );
};

const renderCurrentLocation = (
  currentLocation: string | undefined,
  notes: string | undefined,
  loadId: string,
  setCurrentLocationModalOpen: any,
  setSelectedLocation: any
) => {
  if (!currentLocation && !notes) return 'N/A';

  const openCurrentLocationModal = () => {
    setSelectedLocation({
      currentLocation,
      notes,
    });
    setCurrentLocationModalOpen(true);
  };

  const hasContent = currentLocation || notes;
  const displayText = currentLocation || 'N/A';

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Box sx={{ display: 'block', alignItems: 'center', flexWrap: 'wrap' }}>
        <Typography
          fontSize={{xs:13, md:14}}
          className="tellipsis"
          title={displayText}
          sx={{ mr: 1, lineHeight:'14px', fontWeight:'600'}}
        >
          {displayText}
        </Typography>
        {hasContent && (
          <Button
            color="primary"
            //startIcon={<VisibilityIcon />}
            onClick={(e) => {
              e.stopPropagation();
              openCurrentLocationModal();
            }}
            sx={{
              p: 0,
              minHeight: 'auto',
              minWidth: 'auto',
              textDecoration: 'none',
              fontSize: '12px',
              color:'#0061ff',
              fontWeight: 600,
              lineHeight:1,
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
              },
              '& .MuiButton-startIcon svg': {
                marginRight: '-3px',
                color:'#0061ff',
                fontSize:'12px',
              },
            }}
          >
            Read more
          </Button>
        )}
      </Box>
    </Box>
  );
};

export { renderAddress, AddressModal, CurrentLocationModal, renderCurrentLocation }
